// Helpers compartidos para incidentes CAD.
// Normalización extraída del computed `corporaciones` de
// IncidentDispatchPanel.vue (sin la corporación virtual PRUEBAS).

// El backend entrega attributes.corporaciones en 3 shapes:
//   1. Array de objetos [{corporacion, folioEmergencia, emergenciaCerrada}]
//   2. Array de strings ['CRUM', 'CMMNAU']
//   3. String CSV 'CRUM, CMMNAU, PE'
// Devuelve siempre array de objetos { corporacion, ... }.
export function normalizeCorporaciones(raw) {
  if (!raw) return []
  let arr = raw
  if (typeof raw === 'string') {
    arr = raw.split(',').map((s) => s.trim()).filter(Boolean)
  }
  if (!Array.isArray(arr)) return []
  return arr
    .map((c) => (typeof c === 'string' ? { corporacion: c } : c))
    .filter((c) => c && c.corporacion)
}

// Corporaciones del usuario como array de strings.
export function normalizeUserCorporaciones(user) {
  const raw = user && user.attributes && user.attributes.corporaciones
  return normalizeCorporaciones(raw).map((c) => c.corporacion)
}

// ¿El usuario puede ver este incidente?
// Semántica CAD (default): usuario sin corporaciones = acceso a TODAS.
// Semántica portal ({ emptyMeansNone: true }): sin corporaciones = NADA.
export function userCanSeeIncident(user, incident, opts) {
  const emptyMeansNone = !!(opts && opts.emptyMeansNone)
  const userCorps = normalizeUserCorporaciones(user)
  if (!userCorps.length) return !emptyMeansNone
  const attrs = (incident && incident.attributes) || {}
  const incCorps = normalizeCorporaciones(attrs.corporaciones).map((c) => c.corporacion)
  if (!incCorps.length) return false
  return incCorps.some((c) => userCorps.indexOf(c) !== -1)
}

// ¿El usuario tiene la bandera del portal de terceros? (flag portal_incidents).
// La consume el validate de la ruta incident-portal (router/routes.js); el
// guard de encierro usa `isLockedToPortal`, que es estrictamente más
// restrictiva.
//
// INVARIANTE que evita un loop infinito de redirects portal↔aterrizaje: todo
// usuario encerrado tiene que pasar el validate de la ruta del portal. Hoy se
// cumple por implicación —`isLockedToPortal` ⇒ `isPortalIncidentsUser`—, no
// por identidad. Si alguna vez el validate se vuelve más restrictivo que el
// candado, ese loop reaparece.
//
// Acepta boolean true o string 'true' (los flags en attributes llegan en
// ambos formatos según el path de escritura al backend).
export function isPortalIncidentsUser(user) {
  const flag = user && user.attributes && user.attributes.portal_incidents
  return flag === true || flag === 'true'
}

// El encierro del portal es contención para terceros, no un permiso. No
// aplica a administradores: encerrar al superusuario lo dejaría sin ninguna
// vía de recuperación por interfaz, porque estando encerrado no puede llegar
// al formulario de Usuarios para quitarse la bandera. La combinación
// admin+portal_incidents es casi siempre accidental; dejar ver de más a un
// administrador es peor modo de fallo que encerrarlo sin salida.
// Consumida por el guard (router/index.js), resolveLandingRoute
// (router/access.js) y el computed estaEncerrado (views/IncidentPortal.vue).
export function isLockedToPortal(user) {
  if (!user || user.administrator) return false
  return isPortalIncidentsUser(user)
}
